import React, { useEffect, useState } from "react";

const counters = [
  { label: "Revenue Generated", end: 150, suffix: "M+", prefix: "$", duration: 8000 },
  { label: "Happy Clients", end: 100, suffix: "+", prefix: "", duration: 6000 },
  { label: "Industries Served", end: 12, suffix: "+", prefix: "", duration: 3000 },
  { label: "Client Retention", end: 95, suffix: "%", prefix: "", duration: 5000 },
];

const AchievementSection = () => {
  const [counts, setCounts] = useState(counters.map(() => 0));

  useEffect(() => {
    const startTimes = new Array(counters.length).fill(null);
    let animationFrame;

    const update = (timestamp) => {
      const newCounts = [...counts];
      let allDone = true;

      counters.forEach((counter, i) => {
        if (!startTimes[i]) startTimes[i] = timestamp;

        const progress = timestamp - startTimes[i];
        const percent = Math.min(progress / counter.duration, 1);
        const value = Math.floor(counter.end * percent);

        newCounts[i] = value;

        if (percent < 1) {
          allDone = false;
        }
      });

      setCounts(newCounts);

      if (!allDone) {
        animationFrame = requestAnimationFrame(update);
      }
    };

    animationFrame = requestAnimationFrame(update);

    return () => cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div className="achievement-section ftfl0">
      <h2>
        Our <span className="text-warning"> Achievements</span>
      </h2>
      <div className="achievement-items">
        {counters.map((counter, i) => (
          <div className="achievement-box" key={i}>
            <h3>
              {counter.prefix}
              {counts[i]}
              {counter.suffix}
            </h3>
            <p>{counter.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AchievementSection;
